import { useEffect, useState } from "react";

export default function useWalletContext() {
  const [ctx, setCtx] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;

    (async () => {
      setLoading(true);
      setErr("");

      try {
        const token = localStorage.getItem("authToken");
        const headers = { Authorization: `Bearer ${token}` };

        const [pmRes, detailsRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/wallet/payment-methods`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/api/wallet/details`, { headers }),
        ]);

        const pmData = await pmRes.json();
        const detailsData = await detailsRes.json();

        if (!pmRes.ok) throw new Error(pmData.message || "Failed to load payment methods");
        if (!detailsRes.ok) throw new Error(detailsData.message || "Failed to load wallet details");

        if (!alive) return;

        const methods = normalizeMethods(pmData);
        const displayCurrency = String(detailsData?.display?.currency || "CAD").toUpperCase();
        const rateCadToDisplay = Number(detailsData?.display?.rateCadToDisplay || 1);

        setCtx({
          ...pmData,
          methods,

          ledgerCurrency: "CAD",
          displayCurrency,
          rateCadToDisplay,

          wallet: detailsData?.wallet || null,
          display: detailsData?.display || null,
          profile: detailsData?.profile || null,
        });
      } catch (e) {
        if (alive) setErr(e.message);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  return { ctx, loading, err };
}

function normalizeMethods(data) {
  const methodsRaw = data?.methods || data?.paymentMethods || [];
  return (Array.isArray(methodsRaw) ? methodsRaw : [])
    .map((m) => ({
      code: m.code || m.method || m.id || "",
      label: m.label || m.name || m.code || "Méthode",
      rails: Array.isArray(m.rails) ? m.rails : [],
      ...m,
    }))
    .filter((m) => m.code);
}
